export const emails = {
  "elee@mozilla.com": "ed",
  "dmose@mozilla.org": "dmose",
  "dmosedale@mozilla.com": "dmose",
  "pdahiya@mozilla.com": "punam",
  "emcminn@mozilla.com": "emily",
  "shughes@mozilla.com": "aminomancer",
  "vtay@mozilla.com": "venetia",
  "halemu@mozilla.com": "hanna",
  "jprickett@mozilla.com": "jason",
  "mjung@mozilla.com": "mimi",
  "sachung@mozilla.com": "sarah",
  "mviar@mozilla.com": "meg",
};

export const teams = {
  omc: [
    "dmosedale@mozilla.com",
    "emcminn@mozilla.com",
    "halemu@mozilla.com",
    "jprickett@mozilla.com",
    "mjung@mozilla.com",
    "shughes@mozilla.com",
    "sachung@mozilla.com",
    "mviar@mozilla.com",
  ],
};
